export const rePriceFormationOrderConstants = {
	GetPaged: {
		SUCCESS : 'GET_PAGED_PRICE_FORMATION_ORDER_SUCCESS',
		REQUEST : 'GET_PAGED_PRICE_FORMATION_ORDER_REQUEST',
		FAILURE : 'GET_PAGED_PRICE_FORMATION_ORDER_FAILURE'
	},
	GetPagedAudit: {
		SUCCESS : 'GET_PAGED_AUDIT_PRICE_FORMATION_ORDER_SUCCESS',
		REQUEST : 'GET_PAGED_AUDIT_PRICE_FORMATION_ORDER_REQUEST',
		FAILURE : 'GET_PAGED_AUDIT_PRICE_FORMATION_ORDER_FAILURE'
	},
	GetPagedAll: {
		REQUEST : 'GET_PAGED_ALL_PRICE_FORMATION_ORDER_REQUEST',
		SUCCESS : 'GET_PAGED_ALL_PRICE_FORMATION_ORDER_SUCCESS',
		FAILURE : 'GET_PAGED_ALL_PRICE_FORMATION_ORDER_FAILURE'
	},
	GetList: {
		REQUEST : 'GET_LIST_PRICE_FORMATION_ORDER_REQUEST',
		SUCCESS : 'GET_LIST_PRICE_FORMATION_ORDER_SUCCESS',
		FAILURE : 'GET_LIST_PRICE_FORMATION_ORDER_FAILURE'
	},
	Create: {
		REQUEST : 'CREATE_PRICE_FORMATION_ORDER_REQUEST',
		SUCCESS : 'CREATE_PRICE_FORMATION_ORDER_SUCCESS',
		FAILURE : 'CREATE_PRICE_FORMATION_ORDER_FAILURE'
	},
	Delete: {
		REQUEST : 'DELETE_PRICE_FORMATION_ORDER_REQUEST',
		SUCCESS : 'DELETE_PRICE_FORMATION_ORDER_SUCCESS',
		FAILURE : 'DELETE_PRICE_FORMATION_ORDER_FAILURE'
	},
	Update: {
		REQUEST : 'UPDATE_PRICE_FORMATION_ORDER_REQUEST',
		SUCCESS : 'UPDATE_PRICE_FORMATION_ORDER_SUCCESS',
		FAILURE : 'UPDATE_PRICE_FORMATION_ORDER_FAILURE'
	},
	Restore: {
		REQUEST : 'RESTORE_PRICE_FORMATION_ORDER_REQUEST',
		SUCCESS : 'RESTORE_PRICE_FORMATION_ORDER_SUCCESS',
		FAILURE : 'RESTORE_PRICE_FORMATION_ORDER_FAILURE'
	},
	CLEAR: 'CLEAR_PRICE_FORMATION_ORDER'
}